import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { EMAIL_ADDED_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { getLangCountryPrefix } from 'apps/auth/helpers/utils';

export const SuccessStatus = (props) => {
    useEffect(() => {
        props.sendEvent(EMAIL_ADDED_SCREEN_SHOWN);
    }, []);

    return (
        <BaseLayout>
            <InfoPage animatedIconSuccess headerText={props.successTitle} backUrl={`${getLangCountryPrefix(props.lang, props.country)}`} leftCloseIcon isTagA />
        </BaseLayout>
    );
};

SuccessStatus.propTypes = {
    successTitle: PropTypes.string,
    lang: PropTypes.string,
    country: PropTypes.string,
};
